/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"
import { SocialIcon } from "react-social-icons"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author
          social {
            twitter
          }
        }
      }
    }
  `)

  const { author, social } = data.site.siteMetadata
  return (
    <>
      <div
        style={{
          display: `flex`,
        }}
      >
        <p>
          Written by <strong>{author}</strong> who works and <a href="https://photos.conorbroderick.net" target="_blank" rel="noreferrer">takes photos</a> in Dublin.
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '3%',
          marginBottom: '1.25em',
        }}
      >
        <SocialIcon url="https://github.com/conr" style={{ color: '#fff' }} target="_blank" rel="noreffer"/>
        <SocialIcon url="https://www.linkedin.com/in/conor-broderick-1966a28a/" style={{ color: '#fff' }} target="_blank" rel="noreffer" />
        <SocialIcon url="https://instagram.com/shutter.ireland" style={{ color: '#fff' }} target="_blank" rel="noreffer" />
        <SocialIcon url="https://twitter.com/conorb" style={{ color: '#fff' }} target="_blank" rel="noreffer" />
        <SocialIcon url="https://stackoverflow.com/users/2948793/conor" style={{ color: '#fff' }} target="_blank" rel="noreffer" />
      </div>
    </>
  )
}

export default Bio
